var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isModeLabel
        ? _c(
            "v-tabs",
            {
              staticClass: "billing-tab",
              attrs: { color: "transparent", "show-arrows": "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [
              _c("v-tabs-slider", { attrs: { color: "primary" } }),
              _vm._v(" "),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { md3: "" } },
                    _vm._l(_vm.tabs, function(tabItem) {
                      return _c("v-tab", { key: tabItem }, [
                        _c("span", { staticClass: "tabItem" }, [
                          _vm._v(_vm._s(tabItem))
                        ])
                      ])
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-tabs-items",
                {
                  attrs: { touchless: "" },
                  model: {
                    value: _vm.tab,
                    callback: function($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab"
                  }
                },
                _vm._l(2, function(item, index) {
                  return _c(
                    "v-tab-item",
                    { key: "item" + index },
                    [
                      index === 0
                        ? [
                            _c("PaginationController", {
                              ref: "tableController",
                              refInFor: true,
                              attrs: {
                                getDataActionName:
                                  _vm.warehouseKey === "system"
                                    ? "getSystemTransactionsPagination"
                                    : "getWarehouseTransactionsPagination",
                                actionPredicates: _vm.actionPredicates,
                                historyLimit: _vm.historyLimit,
                                haveStartDate: true,
                                select: _vm.transactionType,
                                outsideScrollToBottom:
                                  _vm.outsideScrollToBottom,
                                haveSearchBox: _vm.warehouseKey === "system",
                                searchBoxLabel: _vm.$t("searchForKeywords"),
                                hasTimeZoneSearchBox: true,
                                zoneType: _vm.zoneType
                              },
                              on: {
                                "update:zoneType": function($event) {
                                  _vm.zoneType = $event
                                },
                                "update:zone-type": function($event) {
                                  _vm.zoneType = $event
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "dataTable",
                                    fn: function() {
                                      return [
                                        _c("v-data-table", {
                                          staticClass: "elevation-1",
                                          attrs: {
                                            headers: _vm.headers,
                                            items:
                                              _vm.sortWarehouseTransactions,
                                            "hide-actions": ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "items",
                                                fn: function(ref) {
                                                  var item = ref.item
                                                  return [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            +_vm.zoneType === 0
                                                              ? _vm.toTimestampString(
                                                                  item.createTime
                                                                )
                                                              : _vm.toTimestampStringUTC(
                                                                  item.createTime
                                                                )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left text-capitalize"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              "" +
                                                                (item.transactionType ||
                                                                  (item.type ===
                                                                  "label"
                                                                    ? "Fee"
                                                                    : item.type)) +
                                                                (item.subtype
                                                                  ? " - " +
                                                                    item.subtype.toUpperCase() +
                                                                    _vm.getBusinessId(
                                                                      item
                                                                    )
                                                                  : "")
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        item.transactionType ===
                                                          "deposit" ||
                                                        item.type === "deposit"
                                                          ? [
                                                              item.subType ===
                                                              "AliPay"
                                                                ? _c(
                                                                    "v-layout",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.subType
                                                                        ) +
                                                                          " - " +
                                                                          _vm._s(
                                                                            item.orderId
                                                                          )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "v-layout",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.cardType
                                                                        ) +
                                                                          " - ***** " +
                                                                          _vm._s(
                                                                            item.last4
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                              _vm._v(" "),
                                                              _c("v-layout", [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle: {
                                                                      width:
                                                                        "55px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "deposit"
                                                                        )
                                                                      ) + ":"
                                                                    )
                                                                  ]
                                                                ),
                                                                _c("div", [
                                                                  _vm._v(
                                                                    "$" +
                                                                      _vm._s(
                                                                        item.originDepositAmount ||
                                                                          item.amount
                                                                      )
                                                                  ),
                                                                  item.subType ===
                                                                  "AliPay"
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "($" +
                                                                              _vm._s(
                                                                                item.transactionFee ||
                                                                                  0
                                                                              ) +
                                                                              ")"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ])
                                                              ]),
                                                              _vm._v(" "),
                                                              item.bonuses &&
                                                              item.bonuses
                                                                .details
                                                                .length > 0
                                                                ? _c(
                                                                    "v-layout",
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticStyle: {
                                                                            width:
                                                                              "55px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "bonus"
                                                                              )
                                                                            ) +
                                                                              ":"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.bonuses.details
                                                                                .map(
                                                                                  function(
                                                                                    promotion
                                                                                  ) {
                                                                                    return (
                                                                                      "$" +
                                                                                      promotion.bonus
                                                                                    )
                                                                                  }
                                                                                )
                                                                                .join(
                                                                                  " + "
                                                                                )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          : [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "billing-note"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.note
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    item.amount ||
                                                    item.amount === 0
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left",
                                                            style:
                                                              "color: " +
                                                              (item.amount > 0
                                                                ? "green"
                                                                : "red")
                                                          },
                                                          [
                                                            item.bonuses &&
                                                            item.bonuses.details
                                                              .length > 0
                                                              ? [
                                                                  _vm._v(
                                                                    "\n                      $" +
                                                                      _vm._s(
                                                                        item.amount +
                                                                          item
                                                                            .bonuses
                                                                            .total
                                                                      ) +
                                                                      "\n                    "
                                                                  )
                                                                ]
                                                              : [
                                                                  _vm._v(
                                                                    "\n                      $" +
                                                                      _vm._s(
                                                                        item.amount
                                                                      ) +
                                                                      "\n                    "
                                                                  )
                                                                ]
                                                          ],
                                                          2
                                                        )
                                                      : item.type === "label"
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left",
                                                            style:
                                                              "color: " +
                                                              (item.totalAmount >
                                                              0
                                                                ? "red"
                                                                : "green")
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    $" +
                                                                _vm._s(
                                                                  item.type ===
                                                                    "label"
                                                                    ? -item.totalAmount
                                                                    : item.amount
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left",
                                                            style:
                                                              "color: " +
                                                              (item.amount <=
                                                                0 ||
                                                              item.totalAmount >
                                                                0
                                                                ? "green"
                                                                : "red")
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    $" +
                                                                _vm._s(
                                                                  item.amount ||
                                                                    -item.totalAmount
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        ),
                                                    _vm._v(" "),
                                                    !_vm.$store.getters
                                                      .isModeLabel ||
                                                    _vm.isClientModelLabel
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "$" +
                                                                _vm._s(
                                                                  item.newBalance
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !_vm.isTenant
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            item.operator
                                                              ? _c("v-layout", [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        item.operator
                                                                      ) +
                                                                      "\n                    "
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        item.subtype !== "pod"
                                                          ? _c(
                                                              "v-layout",
                                                              [
                                                                [
                                                                  "fee",
                                                                  "deposit",
                                                                  "adjust"
                                                                ].includes(
                                                                  item.transactionType ||
                                                                    item.type
                                                                )
                                                                  ? _c(
                                                                      "v-flex",
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "primary",
                                                                              flat:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.showTransactionDetail(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "details"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm.warehouseKey ===
                                                                      "system" &&
                                                                    [
                                                                      "adjust",
                                                                      "label"
                                                                    ].includes(
                                                                      item.type
                                                                    ) &&
                                                                    item.details
                                                                  ? _c(
                                                                      "v-flex",
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "primary",
                                                                              flat:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.showTransactionDetail(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "details"
                                                                                )
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  },
                                  _vm.warehouseKey === "system"
                                    ? {
                                        key: "beforeSearchBox",
                                        fn: function() {
                                          return [
                                            _c(
                                              "v-flex",
                                              { attrs: { md3: "" } },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    items: _vm.transactionTypes,
                                                    "item-value": "value",
                                                    "item-text": "name",
                                                    label: _vm.$t(
                                                      "transactionType"
                                                    )
                                                  },
                                                  model: {
                                                    value: _vm.transactionType,
                                                    callback: function($$v) {
                                                      _vm.transactionType = $$v
                                                    },
                                                    expression:
                                                      "transactionType"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    : {
                                        key: "beforeMenu",
                                        fn: function() {
                                          return [
                                            _c(
                                              "v-flex",
                                              { attrs: { md3: "" } },
                                              [
                                                _c("v-autocomplete", {
                                                  attrs: {
                                                    items: _vm.transactionTypes,
                                                    "item-value": "value",
                                                    "item-text": "name",
                                                    label: _vm.$t(
                                                      "transactionType"
                                                    )
                                                  },
                                                  model: {
                                                    value: _vm.transactionType,
                                                    callback: function($$v) {
                                                      _vm.transactionType = $$v
                                                    },
                                                    expression:
                                                      "transactionType"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-flex", { attrs: { md1: "" } })
                                          ]
                                        },
                                        proxy: true
                                      }
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.warehouseTransactions,
                                callback: function($$v) {
                                  _vm.warehouseTransactions = $$v
                                },
                                expression: "warehouseTransactions"
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      index === 1
                        ? [
                            _c("PaginationController", {
                              ref: "tableController",
                              refInFor: true,
                              attrs: {
                                getDataActionName: "getApiTransactions",
                                actionPredicates: _vm.apiActionPredicates,
                                historyLimit: _vm.apiHistoryLimit,
                                haveStartDate: true,
                                startDate: _vm.startDate,
                                select: _vm.apiTransactionType,
                                outsideScrollToBottom:
                                  _vm.outsideScrollToBottom,
                                haveSearchBox: false,
                                hasTimeZoneSearchBox: true,
                                zoneType: _vm.zoneType,
                                isApi: true
                              },
                              on: {
                                "update:zoneType": function($event) {
                                  _vm.zoneType = $event
                                },
                                "update:zone-type": function($event) {
                                  _vm.zoneType = $event
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "dataTable",
                                    fn: function() {
                                      return [
                                        _c("v-data-table", {
                                          staticClass: "elevation-1",
                                          attrs: {
                                            headers: _vm.headers,
                                            items: _vm.apiLabelTransactions,
                                            "hide-actions": ""
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "items",
                                                fn: function(ref) {
                                                  var item = ref.item
                                                  return [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            +_vm.zoneType === 0
                                                              ? _vm.toTimestampString(
                                                                  item.createTime
                                                                )
                                                              : _vm.toTimestampStringUTC(
                                                                  item.createTime
                                                                )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left text-capitalize"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              "" +
                                                                (item.transactionType ||
                                                                  (item.type ===
                                                                  "label"
                                                                    ? "Fee"
                                                                    : item.type)) +
                                                                (item.subtype
                                                                  ? " - " +
                                                                    item.subtype.toUpperCase() +
                                                                    _vm.getBusinessId(
                                                                      item
                                                                    )
                                                                  : "")
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        item.transactionType ===
                                                          "deposit" ||
                                                        item.type === "deposit"
                                                          ? [
                                                              item.subType ===
                                                              "AliPay"
                                                                ? _c(
                                                                    "v-layout",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.subType
                                                                        ) +
                                                                          " - " +
                                                                          _vm._s(
                                                                            item.orderId
                                                                          )
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "v-layout",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.cardType
                                                                        ) +
                                                                          " - ***** " +
                                                                          _vm._s(
                                                                            item.last4
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                              _vm._v(" "),
                                                              _c("v-layout", [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle: {
                                                                      width:
                                                                        "55px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "deposit"
                                                                        )
                                                                      ) + ":"
                                                                    )
                                                                  ]
                                                                ),
                                                                _c("div", [
                                                                  _vm._v(
                                                                    "$" +
                                                                      _vm._s(
                                                                        item.originDepositAmount ||
                                                                          item.amount
                                                                      )
                                                                  ),
                                                                  item.subType ===
                                                                  "AliPay"
                                                                    ? _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            "($" +
                                                                              _vm._s(
                                                                                item.transactionFee ||
                                                                                  0
                                                                              ) +
                                                                              ")"
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ])
                                                              ]),
                                                              _vm._v(" "),
                                                              item.bonuses &&
                                                              item.bonuses
                                                                .details
                                                                .length > 0
                                                                ? _c(
                                                                    "v-layout",
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticStyle: {
                                                                            width:
                                                                              "55px"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "bonus"
                                                                              )
                                                                            ) +
                                                                              ":"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              item.bonuses.details
                                                                                .map(
                                                                                  function(
                                                                                    promotion
                                                                                  ) {
                                                                                    return (
                                                                                      "$" +
                                                                                      promotion.bonus
                                                                                    )
                                                                                  }
                                                                                )
                                                                                .join(
                                                                                  " + "
                                                                                )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          : [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "billing-note"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.note
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    item.amount ||
                                                    item.amount === 0
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left",
                                                            style:
                                                              "color: " +
                                                              (item.amount > 0
                                                                ? "green"
                                                                : "red")
                                                          },
                                                          [
                                                            item.bonuses &&
                                                            item.bonuses.details
                                                              .length > 0
                                                              ? [
                                                                  _vm._v(
                                                                    "\n                      $" +
                                                                      _vm._s(
                                                                        item.amount +
                                                                          item
                                                                            .bonuses
                                                                            .total
                                                                      ) +
                                                                      "\n                    "
                                                                  )
                                                                ]
                                                              : [
                                                                  _vm._v(
                                                                    "\n                      $" +
                                                                      _vm._s(
                                                                        item.amount
                                                                      ) +
                                                                      "\n                    "
                                                                  )
                                                                ]
                                                          ],
                                                          2
                                                        )
                                                      : item.type === "label"
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left",
                                                            style:
                                                              "color: " +
                                                              (item.totalAmount >
                                                              0
                                                                ? "red"
                                                                : "green")
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    $" +
                                                                _vm._s(
                                                                  item.type ===
                                                                    "label"
                                                                    ? -item.totalAmount
                                                                    : item.amount
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        )
                                                      : _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left",
                                                            style:
                                                              "color: " +
                                                              (item.amount <=
                                                                0 ||
                                                              item.totalAmount >
                                                                0
                                                                ? "green"
                                                                : "red")
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    $" +
                                                                _vm._s(
                                                                  item.amount ||
                                                                    -item.totalAmount
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        ),
                                                    _vm._v(" "),
                                                    !_vm.$store.getters
                                                      .isModeLabel ||
                                                    _vm.isClientModelLabel
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "$" +
                                                                _vm._s(
                                                                  item.newBalance
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !_vm.isTenant
                                                      ? _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            item.operator
                                                              ? _c("v-layout", [
                                                                  _vm._v(
                                                                    "\n                      " +
                                                                      _vm._s(
                                                                        item.operator
                                                                      ) +
                                                                      "\n                    "
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        item.subtype !== "pod"
                                                          ? _c(
                                                              "v-layout",
                                                              [
                                                                [
                                                                  "fee",
                                                                  "deposit",
                                                                  "adjust"
                                                                ].includes(
                                                                  item.transactionType ||
                                                                    item.type
                                                                )
                                                                  ? _c(
                                                                      "v-flex",
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "primary",
                                                                              flat:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.showTransactionDetail(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                          " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "details"
                                                                                  )
                                                                                ) +
                                                                                "\n                        "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm.warehouseKey ===
                                                                      "system" &&
                                                                    [
                                                                      "label-invoice",
                                                                      "adjust",
                                                                      "label"
                                                                    ].includes(
                                                                      item.type
                                                                    ) &&
                                                                    item.details
                                                                  ? _c(
                                                                      "v-flex",
                                                                      [
                                                                        _c(
                                                                          "v-btn",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "primary",
                                                                              flat:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                $event.stopPropagation()
                                                                                return _vm.showTransactionDetail(
                                                                                  item
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                          " +
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "details"
                                                                                  )
                                                                                ) +
                                                                                "\n                        "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  },
                                  {
                                    key: "beforeMenu",
                                    fn: function() {
                                      return [
                                        _c(
                                          "v-flex",
                                          { attrs: { md3: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                items: _vm.apiTransactionTypes,
                                                "item-value": "value",
                                                "item-text": "name",
                                                label: _vm.$t("transactionType")
                                              },
                                              model: {
                                                value: _vm.apiTransactionType,
                                                callback: function($$v) {
                                                  _vm.apiTransactionType = $$v
                                                },
                                                expression: "apiTransactionType"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: _vm.apiLabelTransactions,
                                callback: function($$v) {
                                  _vm.apiLabelTransactions = $$v
                                },
                                expression: "apiLabelTransactions"
                              }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                }),
                1
              )
            ],
            1
          )
        : _c("PaginationController", {
            ref: "tableController",
            attrs: {
              getDataActionName:
                _vm.warehouseKey === "system"
                  ? "getSystemTransactionsPagination"
                  : "getWarehouseTransactionsPagination",
              actionPredicates: _vm.actionPredicates,
              historyLimit: _vm.historyLimit,
              haveStartDate: true,
              select: _vm.transactionType,
              outsideScrollToBottom: _vm.outsideScrollToBottom,
              haveSearchBox: _vm.warehouseKey === "system",
              searchBoxLabel: _vm.$t("searchForKeywords"),
              hasTimeZoneSearchBox: true,
              zoneType: _vm.zoneType
            },
            on: {
              "update:zoneType": function($event) {
                _vm.zoneType = $event
              },
              "update:zone-type": function($event) {
                _vm.zoneType = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "dataTable",
                  fn: function() {
                    return [
                      _c("v-data-table", {
                        staticClass: "elevation-1",
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.sortWarehouseTransactions,
                          "hide-actions": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "items",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    _vm._s(
                                      +_vm.zoneType === 0
                                        ? _vm.toTimestampString(item.createTime)
                                        : _vm.toTimestampStringUTC(
                                            item.createTime
                                          )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-xs-left text-capitalize"
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          "" +
                                            (item.transactionType ||
                                              (item.type === "label"
                                                ? "Fee"
                                                : item.type)) +
                                            (item.subtype
                                              ? " - " +
                                                item.subtype.toUpperCase() +
                                                _vm.getBusinessId(item)
                                              : "")
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-left" },
                                  [
                                    item.transactionType === "deposit" ||
                                    item.type === "deposit"
                                      ? [
                                          item.subType === "AliPay"
                                            ? _c("v-layout", [
                                                _vm._v(
                                                  _vm._s(item.subType) +
                                                    " - " +
                                                    _vm._s(item.orderId)
                                                )
                                              ])
                                            : _c("v-layout", [
                                                _vm._v(
                                                  _vm._s(item.cardType) +
                                                    " - ***** " +
                                                    _vm._s(item.last4)
                                                )
                                              ]),
                                          _vm._v(" "),
                                          _c("v-layout", [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: { width: "55px" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("deposit")) +
                                                    ":"
                                                )
                                              ]
                                            ),
                                            _c("div", [
                                              _vm._v(
                                                "$" +
                                                  _vm._s(
                                                    item.originDepositAmount ||
                                                      item.amount
                                                  )
                                              ),
                                              item.subType === "AliPay"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "($" +
                                                        _vm._s(
                                                          item.transactionFee ||
                                                            0
                                                        ) +
                                                        ")"
                                                    )
                                                  ])
                                                : _vm._e()
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          item.bonuses &&
                                          item.bonuses.details.length > 0
                                            ? _c("v-layout", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "55px"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("bonus")) +
                                                        ":"
                                                    )
                                                  ]
                                                ),
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.bonuses.details
                                                        .map(function(
                                                          promotion
                                                        ) {
                                                          return (
                                                            "$" +
                                                            promotion.bonus
                                                          )
                                                        })
                                                        .join(" + ")
                                                    )
                                                  )
                                                ])
                                              ])
                                            : _vm._e()
                                        ]
                                      : [
                                          _c(
                                            "div",
                                            { staticClass: "billing-note" },
                                            [_vm._v(_vm._s(item.note))]
                                          )
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                item.amount || item.amount === 0
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "text-xs-left",
                                        style:
                                          "color: " +
                                          (item.amount > 0 ? "green" : "red")
                                      },
                                      [
                                        item.bonuses &&
                                        item.bonuses.details.length > 0
                                          ? [
                                              _vm._v(
                                                "\n              $" +
                                                  _vm._s(
                                                    item.amount +
                                                      item.bonuses.total
                                                  ) +
                                                  "\n            "
                                              )
                                            ]
                                          : [
                                              _vm._v(
                                                "\n              $" +
                                                  _vm._s(item.amount) +
                                                  "\n            "
                                              )
                                            ]
                                      ],
                                      2
                                    )
                                  : item.type === "label"
                                  ? _c(
                                      "td",
                                      {
                                        staticClass: "text-xs-left",
                                        style:
                                          "color: " +
                                          (item.totalAmount > 0
                                            ? "red"
                                            : "green")
                                      },
                                      [
                                        _vm._v(
                                          "\n            $" +
                                            _vm._s(
                                              item.type === "label"
                                                ? -item.totalAmount
                                                : item.amount
                                            ) +
                                            "\n          "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "td",
                                      {
                                        staticClass: "text-xs-left",
                                        style:
                                          "color: " +
                                          (item.amount <= 0 ||
                                          item.totalAmount > 0
                                            ? "green"
                                            : "red")
                                      },
                                      [
                                        _vm._v(
                                          "\n            $" +
                                            _vm._s(
                                              item.amount || -item.totalAmount
                                            ) +
                                            "\n          "
                                        )
                                      ]
                                    ),
                                _vm._v(" "),
                                !_vm.$store.getters.isModeLabel &&
                                !_vm.isClientModelLabel
                                  ? _c("td", { staticClass: "text-xs-left" }, [
                                      _vm._v("$" + _vm._s(item.newBalance))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.isTenant
                                  ? _c(
                                      "td",
                                      { staticClass: "text-xs-left" },
                                      [
                                        item.operator
                                          ? _c("v-layout", [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(item.operator) +
                                                  "\n            "
                                              )
                                            ])
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-center" },
                                  [
                                    item.subtype !== "pod"
                                      ? _c(
                                          "v-layout",
                                          [
                                            [
                                              "fee",
                                              "deposit",
                                              "adjust"
                                            ].includes(
                                              item.transactionType || item.type
                                            )
                                              ? _c(
                                                  "v-flex",
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          color: "primary",
                                                          flat: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.showTransactionDetail(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("details")
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm.warehouseKey === "system" &&
                                                ["adjust", "label"].includes(
                                                  item.type
                                                ) &&
                                                item.details
                                              ? _c(
                                                  "v-flex",
                                                  [
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          color: "primary",
                                                          flat: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.showTransactionDetail(
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("details")
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ]
                  },
                  proxy: true
                },
                _vm.warehouseKey === "system"
                  ? {
                      key: "beforeSearchBox",
                      fn: function() {
                        return [
                          _c(
                            "v-flex",
                            { attrs: { md3: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.transactionTypes,
                                  "item-value": "value",
                                  "item-text": "name",
                                  label: _vm.$t("transactionType")
                                },
                                model: {
                                  value: _vm.transactionType,
                                  callback: function($$v) {
                                    _vm.transactionType = $$v
                                  },
                                  expression: "transactionType"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  : {
                      key: "beforeMenu",
                      fn: function() {
                        return [
                          _c(
                            "v-flex",
                            { attrs: { md3: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.transactionTypes,
                                  "item-value": "value",
                                  "item-text": "name",
                                  label: _vm.$t("transactionType")
                                },
                                model: {
                                  value: _vm.transactionType,
                                  callback: function($$v) {
                                    _vm.transactionType = $$v
                                  },
                                  expression: "transactionType"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { md1: "" } })
                        ]
                      },
                      proxy: true
                    }
              ],
              null,
              true
            ),
            model: {
              value: _vm.warehouseTransactions,
              callback: function($$v) {
                _vm.warehouseTransactions = $$v
              },
              expression: "warehouseTransactions"
            }
          }),
      _vm._v(" "),
      _vm.transactionDetailDialog
        ? _c("BillingTransactionDetail", {
            attrs: {
              transaction: _vm.transactionInEdit,
              isTenant: !!_vm.isTenant
            },
            model: {
              value: _vm.transactionDetailDialog,
              callback: function($$v) {
                _vm.transactionDetailDialog = $$v
              },
              expression: "transactionDetailDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTransactionPopup
        ? _c("TransactionDetailsPopup", {
            attrs: { transaction: _vm.transactionInEdit },
            model: {
              value: _vm.showTransactionPopup,
              callback: function($$v) {
                _vm.showTransactionPopup = $$v
              },
              expression: "showTransactionPopup"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-511af8ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-511af8ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BillingTransactionTable.vue
// module id = null
// module chunks = 